import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckoutTicketsEventModalComponent } from 'src/app/modals/checkout-tickets-event-modal/checkout-tickets-event-modal.component';
import { LoginModalComponent } from 'src/app/modals/login-modal/login-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { EventsService } from 'src/app/services/events.service';
import { MenusService } from 'src/app/services/menus.service';
import { InfoEventModalComponent } from 'src/app/modals/info-event-modal/info-event-modal.component';
import { ShoppingService } from 'src/app/services/shopping.service';
import { SelectTypePayModalComponent } from 'src/app/modals/select-type-pay-modal/select-type-pay-modal.component';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-event-page',
  templateUrl: './event-page.component.html',
  styleUrls: ['./event-page.component.scss'],
})
export class EventPageComponent implements OnInit {
  eventId!: string;
  products!: any;
  event: any = {};

  quantitiesSelect = 0;
  quantities: any = [0, 1, 2, 3, 4, 5];

  loading: any = true;

  userLogin: any = false;

  tickets: any = [];

  // apiLoaded: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private eventsService: EventsService,
    public modal: MatDialog,
    private authService: AuthService,
    private router: Router,
    public shopping: ShoppingService,
    httpClient: HttpClient
  ) {
    // this.apiLoaded = httpClient
    //   .jsonp(
    //     'http://maps.googleapis.com/maps/api/js?key=AIzaSyB_v82VEw--Q1hfz1VKoJ7Qps_kfHPL-c0',
    //     'callback'
    //   )
    //   .pipe(
    //     map(() => true),
    //     catchError(() => of(false))
    //   );
    // console.log(this.apiLoaded);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    await this.authService.getLoginStatus().subscribe((status: boolean) => {
      this.userLogin = status;
    });

    this.route.params.subscribe((params: any) => {
      this.eventId = params.id;

      if (params.marketing) {
        this.shopping.addIdMarketing(params.marketing);
      } else {
        this.shopping.addIdMarketing('');
      }

      this.eventsService.getEvent(this.eventId).subscribe((data: any) => {
        if (data.result) {
          this.shopping.addUidEvent(this.eventId);
          this.event = data.result;
          this.tickets = this.event.tickets || [];

          // let element = document.querySelector('.na') as HTMLElement;

          // element.innerHTML = this.event.name;
        } else {
          Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Evento no existe.',
            text: 'Este Evento ya no existe, fue borrado por el productor',
            showConfirmButton: false,
            timer: 1500,
          });
          this.router.navigate(['events']);
        }

        this.loading = false;
      });
    });
  }

  selectTickets() {
    this.quantitiesSelect = 0;
    this.tickets.forEach((element: any) => {
      if (element.quantitie) {
        this.quantitiesSelect += element.quantitie;
      }
    });
  }

  openCheckout() {
    if (this.userLogin) {
      const ticketsBuy = this.tickets.filter(
        (element: any) => element.quantitie
      );

      const dialogRef = this.modal.open(CheckoutTicketsEventModalComponent, {
        data: { ticketsBuy, eventId: this.eventId },
        disableClose: true,
        width: '100vw',
      });

      dialogRef.afterClosed().subscribe(async (result: any) => {
        if (result) {
        }
      });
    } else {
      const dialogRef = this.modal.open(LoginModalComponent, {
        data: {},
        disableClose: true,
        width: '100vw',
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
        }
      });
    }
  }

  openInfo() {
    const dialogRef = this.modal.open(InfoEventModalComponent, {
      data: this.event,
      disableClose: true,
      width: '100vw',
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
      }
    });
  }

  disableButton() {
    const cart = this.shopping.getShoppingCart();
    const disableButton = !this.userLogin || cart.length == 0;
    return disableButton;
  }

  async openTypePay(): Promise<void> {
    const cart = this.shopping.getShoppingCart();
    if (this.userLogin && cart.length > 0) {
      const dialogRef = this.modal.open(SelectTypePayModalComponent, {
        data: {},
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(async (result) => {});
    }
  }
}
